require("axios");
require("vue");

window.Promise = require('promise');

import Vue from 'vue';
import axios from 'axios';

window.Vue = Vue;
window.axios = axios;

